import React from 'react';
import { useTranslation } from 'react-i18next';
import FadeInSection from './FadeInSection';

const ContactSection: React.FC = () => {
  const { t } = useTranslation('website');

  return (
    <section id="contact" className="py-24 lg:py-32 relative section-alt">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <FadeInSection className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-8 h-[2px] bg-accent-500" />
              <span className="text-accent-400 text-xs font-semibold tracking-wider uppercase">{t('contact.label')}</span>
              <div className="w-8 h-[2px] bg-accent-500" />
            </div>
            <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-4">{t('contact.title')}</h2>
            <p className="text-dark-400" style={{ lineHeight: '1.9' }}>{t('contact.subtitle')}</p>
          </FadeInSection>

          {/* Contact cards */}
          <div className="grid md:grid-cols-3 gap-5 mb-10">
            {[
              { icon: 'mail', title: t('contact.email'), value: t('contact.emailValue'), href: `mailto:${t('contact.emailValue')}` },
              { icon: 'map-pin', title: t('contact.address'), value: t('contact.addressValue'), href: null },
              { icon: 'globe', title: t('contact.website'), value: t('contact.websiteValue'), href: 'https://www.fancypeter.com' },
            ].map((item, i) => (
              <FadeInSection key={i} delay={`fade-in-delay-${i}` as any} className="p-8 rounded-2xl bg-dark-900/40 border border-dark-800/50 text-center card-hover">
                <div className="tech-icon-center mb-5">
                  <i data-lucide={item.icon} className="text-accent-400 text-4xl" />
                </div>
                <h3 className="text-white font-semibold mb-2">{item.title}</h3>
                {item.href ? (
                  <a href={item.href} target="_blank" rel="noopener noreferrer" className="text-dark-400 text-sm hover:text-primary-400 transition-colors">
                    {item.value}
                  </a>
                ) : (
                  <p className="text-dark-400 text-sm">{item.value}</p>
                )}
              </FadeInSection>
            ))}
          </div>

          {/* CTA */}
          <FadeInSection delay="fade-in-delay-3" className="text-center p-10 sm:p-14 rounded-3xl bg-gradient-to-br from-primary-600/20 via-dark-900/60 to-accent-500/10 border border-primary-500/20">
            <h3 className="text-2xl font-bold text-white mb-3">{t('contact.ctaTitle')}</h3>
            <p className="text-dark-400 text-sm mb-8 max-w-md mx-auto" style={{ lineHeight: '1.8' }}>{t('contact.ctaDesc')}</p>
            <a
              href={`mailto:${t('contact.emailValue')}`}
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary-600 hover:bg-primary-500 text-white font-semibold rounded-2xl transition-all shadow-lg shadow-primary-600/25"
            >
              <i data-lucide="send" className="text-sm" />
              {t('contact.sendEmail')}
            </a>
          </FadeInSection>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
